import React from 'react'
import styled from 'styled-components'
import BlockContent from '@sanity/block-content-to-react'
import YouTubeView from '../youTubeView/YouTubeView'

/* 
    Component for Sanity BlockContent with defined serializers 
    
    Handles:
    - responsive youtube 
    - responsive image (max width for image is container width)
*/

const serializers = {
  types: {
    youtube: ({ node: { url } }) => <YouTubeView url={url} />,
  },
}

const BlockContentSanity = ({ blocks }) => (
  <StyledBlockContent blocks={blocks} serializers={serializers} />
)

const StyledBlockContent = styled(BlockContent)`
  img {
    max-width: 100%;
  }
`

export default BlockContentSanity
